import {
    ChangeDetectorRef,
    Component, ElementRef, HostListener,
    Inject,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {Subject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
import { DiaryTasksService, DiaryTasksResponse, OnsiteTask } from '@app/shared/services/diary-tasks.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-view-task-details',
    templateUrl: './view-task-details.component.html',
    styleUrls: ['view-task-details.component.scss'],
})
export class ViewTaskDetailsComponent implements OnInit {
    onClose: Subject<any>;
    subTab: 'incomplete' | 'completed' | 'skipped' = 'incomplete';
    diaryId: number;
    searchTerm$ = new Subject<string>();
    taskCounts = {
        incomplete: 0,
        completed: 0,
        skipped: 0
    };
    tasks: OnsiteTask[] = [];
    loading: boolean = false;
    error: string = '';
    currentSearchTerm: string = '';
    searchText: string = '';
    @ViewChild('activitiesScroll') activitiesScroll!: ElementRef;
    hasScrollbar: boolean = false;

    constructor(
        public bsModalRef: BsModalRef,
        private diaryTasksService: DiaryTasksService
    ) {}

    ngOnInit() {
        this.onClose = new Subject();

        // Set up search debouncing
        this.searchTerm$
            .pipe(
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe(searchTerm => {
                this.currentSearchTerm = searchTerm;
                this.loadTasks();
            });

        // Load initial tasks (which includes counts)
        if (this.diaryId) {
            this.loadTasks();
        }
    }

    loadTasks() {
        if (!this.diaryId) {
            return;
        }

        this.loading = true;
        this.error = '';

        this.diaryTasksService.getTasksByStatus(this.diaryId, this.subTab, this.currentSearchTerm)
            .subscribe(
                (response: DiaryTasksResponse) => {
                    this.tasks = response.tasks;
                    // Update counts from the response
                    this.taskCounts = {
                        incomplete: response.counts.incomplete,
                        completed: response.counts.completed,
                        skipped: response.counts.skipped
                    };
                    this.loading = false;
                },
                (error) => {
                    console.error('Error loading tasks:', error);
                    this.error = 'Failed to load tasks. Please try again.';
                    this.loading = false;
                    this.tasks = [];
                }
            );
    }

    close() {
        this.bsModalRef.hide()
        this.onClose.next()
    }

    subTabOnClick(taskStatus: 'incomplete' | 'completed' | 'skipped') {
        this.subTab = taskStatus;
        this.loadTasks();
    }

    onSearch(event: any) {
        this.searchText = event.target.value;
        this.searchTerm$.next(this.searchText);
    }

    clearSearch() {
        this.searchText = '';
        this.searchTerm$.next('');
    }

    @HostListener('window:resize')
    onResize() {
        this.checkScroll();
    }

    checkScroll() {
        const el = this.activitiesScroll.nativeElement;
        const hasScroll = el.scrollHeight > el.clientHeight;
        this.hasScrollbar = hasScroll;
    }

}
